module.exports = __webpack_public_path__ + "static/media/PowderUS.944656ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Products/PowderUS.jpg
// module id = 317
// module chunks = 0